import { withInstall } from '@tav-ui/utils/with-install'
import FileCard from './index.vue'

export * from './types'
export const TaFileCard = withInstall(FileCard)
export default TaFileCard
